import React from 'react';
import { IProps } from './interfaces';

const KrClose: React.FC<IProps> = ({
  size = 32,
  color = '#FF6900',
  className,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.72 1.83003C6.21383 1.83003 5.8 2.2403 5.8 2.75003V29.25C5.8 29.7562 6.21027 30.17 6.72 30.17H25.28C25.7862 30.17 26.2 29.7598 26.2 29.25V11.6946C26.1934 11.6507 26.19 11.6058 26.19 11.56C26.19 11.3335 26.1004 11.1035 25.9355 10.9278C25.9352 10.9275 25.9349 10.9272 25.9346 10.9269L17.5857 2.11799C17.414 1.93618 17.1699 1.83003 16.92 1.83003H6.72ZM27.9849 11.3949C27.9948 11.4485 28 11.5036 28 11.56V29.25C28 30.7603 26.7738 31.97 25.28 31.97H6.72C5.20973 31.97 4 30.7439 4 29.25V2.75003C4 1.23976 5.22617 0.0300293 6.72 0.0300293H16.92C17.6699 0.0300293 18.3855 0.343659 18.8938 0.881492C18.8936 0.881299 18.8939 0.881684 18.8938 0.881492L27.2454 9.6932C27.6821 10.1572 27.9457 10.7613 27.9849 11.3949Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.56 15.29C9.56 14.9586 9.82863 14.69 10.16 14.69H22.44C22.7714 14.69 23.04 14.9586 23.04 15.29C23.04 15.6214 22.7714 15.89 22.44 15.89H10.16C9.82863 15.89 9.56 15.6214 9.56 15.29ZM9.56 20.44C9.56 20.1086 9.82863 19.84 10.16 19.84H22.44C22.7714 19.84 23.04 20.1086 23.04 20.44C23.04 20.7714 22.7714 21.04 22.44 21.04H10.16C9.82863 21.04 9.56 20.7714 9.56 20.44ZM9.56 25.59C9.56 25.2586 9.82863 24.99 10.16 24.99H22.44C22.7714 24.99 23.04 25.2586 23.04 25.59C23.04 25.9214 22.7714 26.19 22.44 26.19H10.16C9.82863 26.19 9.56 25.9214 9.56 25.59Z"
        fill={color}
      />
    </svg>
  );
};

export default KrClose;
